import React from 'react'
import About from '../component/About'
import Contact from '../component/Contact'
import Footer from '../component/Footer'
import Hero from '../component/Hero'
import Navbar from '../component/Navbar'
import Photography from '../component/Photography'
import Project from '../component/Project'
import Slider from '../component/Slider'
import Technology from '../component/Technology'


const Home = () => {
  return (
    <div>
        <Navbar/>
        <Hero/>
        <About/>
        <Technology/>
        <Project/>
        <Slider/>
        <Photography/>
        <Contact/>
        <Footer/>
    </div>
  )
}

export default Home